/**
 * Represents the height of form components given all available sizes
 */
export const inputHeightDictionary = {
  small: 28,
  standard: 36,
  large: 42,
};
